<template>
  <div class="placeholder"
    :class="{locked, roundedCorners: selectedProductIsRounded}">
    <PdfUploader
      v-if="!locked"
      @upload="onUploadBack"
      control-style="link"
      :extra="{designId}"
      :allow-drag="false"
      >+ back side</PdfUploader>
  </div>
</template>
<style scoped lang="scss">
@import '~scss/colors';

.placeholder {
  height: 120px;
  width: 210px;
  background: white;
  border: 1px solid $gray-1;

  // Put button in middle
  display: flex;
  justify-content: space-around;
  align-items: center;

  // style no back side text
  &.locked::before {
    content: "no back side";
    color: $gray-0;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 2px;
  }
}
.roundedCorners {
  border-radius: 5px;
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: ['bus', 'locked'],
  data() {
    return {allowDrag: true};
  },
  computed: {
    ...mapGetters(['designId', 'selectedProductIsRounded', 'flags']),
  },
  methods: {
    ...mapActions(['setDesign', 'setPage']),
    async onUploadBack(event) {
      event.preventDefault();
      if (this.flags.seamlessBackUpload) {
        // Just update the store. the editor should react.
        // Unfortunately this is buggy, so it's behind a flag (for development purposes)
        await this.setDesign(event.design);
        this.setPage('1'); // Switch to back page (numbered from 0)
      } else {
        console.log('reloading...');
        window.location.reload();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/EditorBackPlaceholder.vue